import script from "./LearningHubDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningHubDetails.vue?vue&type=script&setup=true&lang=js"

import "./LearningHubDetails.vue?vue&type=style&index=0&id=0634e4d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0634e4d0"]])

export default __exports__